export const environments = [
  {
    id: "LIVE",
    name: "Live"
  },
  {
    id: "SANDBOX",
    name: "Sandbox"
  },
]